/**
 * Converte uma string UTF-16 em uma representação de string binária.
 *
 * Esta função utiliza a API `TextEncoder` para codificar a string de entrada em um
 * array de bytes. Em seguida, concatena esses bytes e os converte em uma string binária
 * utilizando `String.fromCharCode`.
 *
 * Fonte:
 * [How to Fix JavaScript btoa() "outside of the Latin1 range" Error?](https://www.designcise.com/web/tutorial/how-to-fix-javascript-btoa-outside-of-the-latin1-range-error).
 *
 * @param {string} strValeu - A string de entrada que será convertida para formato binário.
 * @returns {string} - Uma string que representa a versão binária da string de entrada.
 *
 * @example
 * console.log(btoa(toBinaryStr('🦊'))); // '8J+mig=='
 * console.log(btoa(toBinaryStr('こんにちは'))); // '44GT44KT44Gr44Gh44Gv'
 * console.log(btoa(toBinaryStr('foobar'))); // 'Zm9vYmFy'
 *
 */
function toBinaryStr(strValeu) {
  return strValeu.replaceAll(`’`, `'`);
}

export { toBinaryStr };
